import {Component, Inject, OnInit} from '@angular/core';
import {ConfigurationService} from "../../../services/configuration.service";
import {AuthenticationService} from "../../../services/authentication.service";
import {FormBuilder} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../services/data.service";
import {GlobalConstants} from "../../../common/global-constants";
import {CommonUtils} from "../../../utils/common.utils";

@Component({
  selector: 'app-pending-approval-requests',
  templateUrl: './pending-approval-requests.component.html',
  styleUrls: ['./pending-approval-requests.component.scss']
})
export class PendingApprovalRequestsComponent implements OnInit {

  fetchAllPendingApprovalRequests: string = GlobalConstants.FETCH_ALL_PENDING_APPROVAL_REQUESTS;
  approvalRequestUrl: string = GlobalConstants.SUBMIT_TRANSIT_TIME_APPROVAL_REQUEST_ENDPOINT;


  loading = false;

  pendingApprovalRequests = [];
  filteredPendingApprovalRequests = [];

  user = {};
  countryCodes: any;

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('DataPathUtils') private dataPathUtils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dataService: DataService) {
  }

  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.render();
  }

  async onReviewButtonClick(row, approvalStatus) {
    this.loading = true;
    let requestBody = JSON.parse(JSON.stringify(row));
    requestBody[GlobalConstants.ARC] = this.commonUtils.getArc();
    requestBody[GlobalConstants.APPROVAL_STATUS] = approvalStatus;
    requestBody[GlobalConstants.APPROVED_BY] = requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];

    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions(requestBody);
      if (hasPermission === false){
        this.loading = false;
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }

    this.requestsService.put(this.approvalRequestUrl, requestBody).subscribe(data => {
      this.loading = false;
      this.render();
      this.toastrService.success((approvalStatus ? GlobalConstants.APPROVAL : GlobalConstants.REJECTION) + GlobalConstants.SPACE + GlobalConstants.REQUEST_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS)
    }, error => {
      this.loading = false;
      this.render();
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  render() {
    this.loading = true;
    this.requestsService.put(this.fetchAllPendingApprovalRequests, {}).subscribe(data => {
      this.loading = false;
      this.pendingApprovalRequests = data[GlobalConstants.TRANSIT_TIME_REQUESTS_RESPONSE_KEY];
      this.filteredPendingApprovalRequests = [];
      let arc = this.commonUtils.getArc();
      for (let record in this.pendingApprovalRequests) {
        if (this.pendingApprovalRequests[record][GlobalConstants.ARC] == undefined || this.pendingApprovalRequests[record][GlobalConstants.ARC] == arc) {
          this.filteredPendingApprovalRequests.push(this.pendingApprovalRequests[record]);
        }
      }
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

}
